import { mapChartAvailableCountryIsoCodes } from '../../Charts/models/map-chart-available-regions.const';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { GeographyTypesEnum } from '../../../api/journodex/enum/geography-types.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class RegionPickerFieldService {
    countriesAvailableForMapping: DropdownOptionModel[] = [];

    constructor(private localizationService: LocalizationService) {
        this.setRegionsAvailableForMapChart();
    }

    /**
     * Sets the regions available
     */
    setRegionsAvailableForMapChart(): void {
        const availableCountryIsoCodeKeys = Object.keys(mapChartAvailableCountryIsoCodes);

        availableCountryIsoCodeKeys.forEach((key) => {
            const countryObject = mapChartAvailableCountryIsoCodes[key];

            if (countryObject.mappedInJournodex) {
                this.countriesAvailableForMapping.push({
                    label: this.localizationService.transform(countryObject.name),
                    value: key
                });
            }
        });

        this.sortAvailableCountries(this.countriesAvailableForMapping);
    }

    /**
     * Gets the regions available
     */
    getRegionsAvailableForMapChart(scale: GeographyTypesEnum): DropdownOptionModel[] {
        switch (scale) {
            case GeographyTypesEnum.country:
                return this.countriesAvailableForMapping;
            default:
                return [];
        }
    }

    /**
     * Sorts available countries dropdown option models alphabetically
     */
    sortAvailableCountries(options: DropdownOptionModel[]): void {
        options.sort(
            (optionA, optionB) => {
                const optionAName = optionA.label;
                const optionBName = optionB.label;

                return optionAName.localeCompare(optionBName);
            });
    }
}
